import React, {Component} from "react";
import styles from './detailBloodStationNoInfo.module.scss';

export default class DetailBloodStationNoInfo extends Component<any, any> {
  props: {
    text?: string
  }

  render() {
    const {props} = this
    const {text = 'Информация отсутствует'} = props
    return (
      <div className={styles.DetailBloodStationNoInfo}>
        <h3>{text}</h3>
      </div>
    )
  }
}
